import React from "react";

interface SolomonLogomarkProps {
    className?: string;
    /** Override `currentColor` with an explicit fill. */
    fill?: string;
    /** Accessible label. Defaults to `aria-hidden` (decorative). Pass
     *  a string to expose the mark to assistive tech. */
    title?: string;
}

/**
 * Solomon logomark — the brand glyph alone (no wordmark). Uses
 * `currentColor` for all fills so the color follows the surrounding
 * text color (pair with `text-ember` / `text-foreground-base` etc.).
 * Native aspect ratio 512×439.
 */
export function SolomonLogomark({
    className,
    fill,
    title
}: SolomonLogomarkProps): React.ReactElement {
    return (
        <svg
            viewBox="0 0 512 439"
            fill={fill ?? "currentColor"}
            xmlns="http://www.w3.org/2000/svg"
            role={title ? "img" : undefined}
            aria-label={title}
            aria-hidden={title ? undefined : true}
            className={className}
        >
            <path d="M438.852 0H73.1482V36.5814H438.852V0Z" />
            <path d="M438.855 402.418H475.426L475.426 0.0225601H438.855L438.855 402.418Z" />
            <path d="M36.5778 438.977H73.1482L73.1482 36.5816H36.5778L36.5778 438.977Z" />
            <path d="M292.551 109.742H219.411V146.324H292.551V109.742Z" />
            <path d="M438.844 109.742H292.563V146.324H438.844V109.742Z" />
            <path d="M512 109.742H438.859V146.324H512V109.742Z" />
            <path d="M73.1407 292.676H0V329.257H73.1407V292.676Z" />
            <path d="M219.43 292.676H73.1482V329.257H219.43V292.676Z" />
            <path d="M292.551 292.676H219.411V329.257H292.551V292.676Z" />
            <path d="M438.852 402.418H73.1482V438.999H438.852V402.418Z" />
            <path d="M292.551 219.511C292.551 199.307 276.178 182.929 255.981 182.929C235.784 182.929 219.411 199.307 219.411 219.511C219.411 239.714 235.784 256.092 255.981 256.092C276.178 256.092 292.551 239.714 292.551 219.511Z" />
        </svg>
    );
}
